import { Routes, useLocation } from "react-router-dom";
import "./App.scss";
import {
  AuthRoutes,
  ClientRoutes,
  LoginRoutes,
  ProductRoutes,
  SectorRoutes,
  UserRoutes,
} from "./routes";

import { GoogleOAuthProvider } from "@react-oauth/google";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import PaymentModal from "./pages/Payments/PaymentModal";
import NpsPopUp from "./pages/User/NpsPopUp";

const extractUserId = (userState) => {
  if (!userState) return null;
  return (
    userState?.data?.id ||
    userState?.data?._id ||
    userState?.user?.id ||
    userState?.user?._id ||
    userState?.id ||
    userState?.client?._id ||
    userState?.client?.id ||
    userState?.userId ||
    null
  );
};


function App() {
  const dispatch = useDispatch();
  const location = useLocation();

  const userState = useSelector((state) => state.userReducer || {});
  const { isAuthenticatedUser } = useSelector((state) => state.userReducer);

  /** ---------- Add Google Analytics Script ---------- */
  useEffect(() => {
    const head = document.head;

    const gaScript = document.createElement("script");
    gaScript.src = "https://www.googletagmanager.com/gtag/js?id=G-2HLCMC7W3Z";
    gaScript.async = true;

    const configScript = document.createElement("script");
    configScript.innerHTML = `
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        gtag('config', 'G-2HLCMC7W3Z');
    `;

    head.appendChild(gaScript);
    head.appendChild(configScript);

    console.log("Google Analytics initialized");
  }, []);

  /** ---------- Track Route/Page Views ---------- */
  useEffect(() => {
    if (window.gtag) {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_title: document.title,
      });
      console.log("GA Page Track:", location.pathname);
    }
  }, [location]);


  useEffect(() => {
    const saved = localStorage.getItem("selectedProducts");
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        if (Array.isArray(parsed)) {
          dispatch({
            type: "SET_SELECTED_PRODUCTS",
            payload: parsed,
            meta: { source: "register" },
          });
        }
      } catch (err) {
        console.error("error parsing selectedProducts:", err);
      }
    }
  }, [dispatch]);

  useEffect(() => {
    const saved = localStorage.getItem("productMasterList");
    if (saved) {
      try {
        const parsed = JSON.parse(saved);
        if (Array.isArray(parsed)) {
          dispatch({
            type: "SET_PRODUCT_MASTER_LIST",
            payload: parsed,
          });
        }
      } catch (err) {
        console.error("error parsing productMasterList:", err);
      }
    }
  }, [dispatch]);

  return (
    <>
      <GoogleOAuthProvider clientId={process.env.REACT_APP_URI_GCP_OAUTH_CLIENTID}>
        <PaymentModal />
        {isAuthenticatedUser && <NpsPopUp />}

        <div>
          <Routes>
            {AuthRoutes}
            {UserRoutes}
            {ClientRoutes}
            {ProductRoutes}
            {SectorRoutes}
            {LoginRoutes}
          </Routes>
        </div>
      </GoogleOAuthProvider>
    </>
  );
}

export default App;
